import { action, makeAutoObservable } from "mobx"
import { SchemeStore } from "."
import blockTypes from "../block-types"
import Block from "./block"

class SchemeStoreCreate {

  private store: SchemeStore
  constructor(store: SchemeStore) {
    this.store = store
    makeAutoObservable(this, {
      onMenuItemMouseDown: action.bound,
      onMenuMouseLeave: action.bound
    })
  }

  private leaveEvent: ((e: React.MouseEvent) => void) | null = null
  
  onMenuItemMouseDown = (e: React.MouseEvent, blockType: keyof typeof blockTypes) => {
    this.leaveEvent = (e) => {
      this.leaveEvent = null
      const baseName = blockTypes[blockType].title + " "
      const block = new Block()
      const maxIndex = Array.from(this.store.blocks.values())
        .filter(b => b.data.name && b.data.name.startsWith(baseName))
        .map(b => parseInt(b.data.name.slice(baseName.length)))
        .filter(b => !isNaN(b))
        .reduce((min, val) => Math.max(min, val), 0)

      block.data.name = baseName+(maxIndex+1)

      block.type = blockType
      block.position = { 
        left: e.clientX + this.store.cameraPos.left - 100, 
        top: e.clientY + this.store.cameraPos.top - 20
      }
      this.store.blocks.set(block.id, block)
      this.store.onBlockClick(e, block.id)
    }
    document.addEventListener("mouseup", () => {
      this.leaveEvent = null
    })
  }

  onMenuMouseLeave = (e: React.MouseEvent) => {
    if (this.leaveEvent) this.leaveEvent(e)
  }

}

export default SchemeStoreCreate